import { useQuery } from '@hooks/reactQuery';

import { getParametersBranch } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { refetchOptions } from '@constants/common';
import { MO_BRANCH_PARAMETERS } from '@constants/queryKeys';

export const useQueryParametersBranch = (comparisonId: string) => {
	const {
		data: parametersOptions,
		isLoading: isLoadingParameters,
	} = useQuery({
		queryKey: [MO_BRANCH_PARAMETERS, comparisonId],
		queryFn: extractQueryParams(getParametersBranch),
		select: (options: Array<string>) => fieldsOptionsFormatted(options),
		...refetchOptions,
	});

	return {
		parametersOptions: parametersOptions || [],
		isLoadingParameters,
	};
};
